/**
 * Safe evaluation of challenge completion: progressValue operator targetValue.
 * Uses a whitelist of operators and numeric coercion to avoid eval()/code injection
 * when target.operator and target.target_value come from the database.
 */

const ALLOWED_OPERATORS = new Set(['>=', '>', '<=', '<', '===', '==', '!==', '!=']);

/**
 * @param {number} progressValue - User's progress (e.g. count of log entries)
 * @param {string} operator - Comparison operator from challenge_targets (e.g. '>=')
 * @param {string|number} targetValue - Target from challenge_targets (e.g. 30)
 * @returns {boolean} Whether the target is satisfied
 */
export function evaluateChallengeTarget(progressValue, operator, targetValue) {
  const numProgress = Number(progressValue);
  const numTarget = Number(targetValue);
  if (Number.isNaN(numProgress) || Number.isNaN(numTarget)) return false;
  const op = String(operator).trim();
  if (!ALLOWED_OPERATORS.has(op)) return false;
  switch (op) {
    case '>=': return numProgress >= numTarget;
    case '>':  return numProgress > numTarget;
    case '<=': return numProgress <= numTarget;
    case '<':  return numProgress < numTarget;
    case '===':
    case '==': return numProgress === numTarget;
    case '!==':
    case '!=': return numProgress !== numTarget;
    default:   return false;
  }
}
